import * as React from "react";
import cx from "classnames";

import { TrackClick } from "../../../hoc";
import { ProjectInfoFormProps } from "./ProjectInfoForm";
import FieldSwitch from "./ProjectInfoFormFieldSwitch";
import { ATT_MATRIX_VALS } from "../../Wizard/constants";

const AdvancedProjectFields = (props: ProjectInfoFormProps) => (
  <div className="info-form__advanced">
    <TrackClick
      category="wizard"
      action="Clicked advanced fields toggle"
      label={(!props.showAdvanced).toString()}
      onClick={props.toggleAdvancedFields}
      render={handleClick => (
        <h4 onClick={handleClick}>
          Tùy chọn khác
          <i
            className={cx("fa", "fa-fw", {
              "fa-caret-down": !props.showAdvanced,
              "fa-caret-up": props.showAdvanced,
            })}
          />
        </h4>
      )}
    />
    <div
      className={cx("info-form__advanced-fields", {
        "info-form__advanced-fields--hidden": !props.showAdvanced,
      })}
    >
      <FieldSwitch
        {...props}
        shouldRenderField={att => att === ATT_MATRIX_VALS.ADV}
      />
    </div>
  </div>
);

export default AdvancedProjectFields;



// WEBPACK FOOTER //
// ./src/routes/Step4/components/AdvancedProjectFields.tsx